module.exports = __webpack_public_path__ + "static/media/logohome.8b564b89.png";